/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DSTPinVM {
    title?: string | null;
    description?: string | null;
    latitude?: number;
    longitude?: number;
    color?: string | null;
    id?: number;
    level1?: string | null;
    level2?: string | null;
    level3?: string | null;
    level4?: string | null;
    pinType?: string | null;
    isPublic?: boolean | null;
    hasReadingClub?: boolean | null;
    schoolLevel?: string | null;
    instituteType?: string | null;
    isControl?: boolean | null;
    prePrimary1Girls?: number | null;
    prePrimary1Boys?: number | null;
    prePrimary2Girls?: number | null;
    prePrimary2Boys?: number | null;
    grade1Girls?: number | null;
    grade1Boys?: number | null;
    grade2Girls?: number | null;
    grade2Boys?: number | null;
    totalGirls?: number | null;
    totalBoys?: number | null;
    totalOverall?: number | null;
}

